import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, NgControl, Validators } from '@angular/forms';
import { APP_CONFIG } from '../../../../app.config';
import { AssistantPopoverService } from '../../../../common/assistant-popover.service';
import { ValidationService } from '../../../../common/validation.service';
import { AppConfig } from '../../../../models/config/app-config';
import { VisumErfassungSubFormComponent } from '../../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-stell-vertreter',
  templateUrl: './stell-vertreter.component.html',
  styleUrl: './stell-vertreter.component.scss'
})
export class StellVertreterComponent extends VisumErfassungSubFormComponent implements OnInit {

  model: AppEnvironmentModel;

  constructor(formBuilder: FormBuilder,
              protected validationService: ValidationService,
              controlDir: NgControl,
              assistantPopoverService: AssistantPopoverService,
              @Inject(APP_CONFIG) protected appConfig: AppConfig) {
    super(controlDir, assistantPopoverService);

    this.form = formBuilder.group({
      familienname: [null, [...validationService.getValidators('antragsteller.stellvertreter.familienname'), Validators.required]],
      vorname: [null, [...validationService.getValidators('antragsteller.stellvertreter.vorname'), Validators.required]],
      anschrift: [null, [...validationService.getValidators('antragsteller.stellvertreter.anschrift'), Validators.required]],
      telefon: [null, validationService.getValidators('antragsteller.stellvertreter.telefon')],
      email: [null, validationService.getValidators('antragsteller.stellvertreter.email')]
    });
  }

  ngOnInit() {
    super.ngOnInit();
    this.model = {
      isMek: this.appConfig.umgebung === 'MEK',
      isVidex: this.appConfig.umgebung === 'VIDEX',
      isCVisum: this.appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT',
      isDVisum: this.appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'
    };
    this.form.updateValueAndValidity();
  };
}

export interface AppEnvironmentModel {
  isMek: boolean;
  isVidex: boolean;
  isCVisum: boolean;
  isDVisum: boolean;
}
